// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.batchNumber[data-v-16281fe9] {\n  color: #007efd;\n  cursor: pointer;\n}\n.app-container .searchContainer[data-v-16281fe9] .el-date-editor .el-range-separator {\n  line-height: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
